<div class="flex flex-col flex-auto min-w-0">

  <!-- Header -->
  <app-generic-breadcrumbs terminal="Ads" fallbackIcon="heroicons_solid:newspaper"></app-generic-breadcrumbs>

  <!-- Main -->
  <div class="flex-auto p-6 sm:p-6">
    <app-ads-list adsRoute="/v1/ads"></app-ads-list>
  </div>
</div>